import React from 'react';
import Carousel from './Carousel';
import ContactSection from './ContactSection';
import IndustryFocusSection from './IndustryFocusSection';
import OurServices from './OurServices';
import OurStory from './OurStory';
import WhyChoose from './WhyChoose';

const Home = () => {
    return (
        <div>
            <Carousel />
            <OurStory />
            <OurServices />
            <WhyChoose />
            <IndustryFocusSection />
            <ContactSection />
        </div>
    );
};

export default Home;
